<template>
  <div class="product-intro">
    <!-- 导航栏（与行业解决方案页保持一致） -->
    <nav class="nav-bar">
      <div class="logo">
        <span class="logo-symbol"><img src="https://aics-public.oss-cn-beijing.aliyuncs.com/images/sunrise-logo.png" width="60" height="60" alt="小晖智能客服"/></span>
        <span class="logo-text">小晖AI客服平台</span>
      </div>
      <div class="nav-links">
        <a href="/solutions">行业解决方案</a>
        <a href="" class="active">产品介绍</a>
        <a href="Pricing">定价策略</a>
        <a href="#">技术博客</a>
        <a href="#">关于我们</a>
        <a href="/login" class="secondary-btn">登录</a>
      </div>
    </nav>
    
    <!-- 网站建设中标识 -->
    <div class="construction-banner">
      <div class="construction-content">
        <span class="construction-icon">🚧</span>
        <span class="construction-text">网站建设中，敬请期待</span>
      </div>
    </div>

    <!-- 页面主要内容 -->
    <main class="main-content">
      <!-- 页面标题 -->
      <section class="page-header">
        <h1>产品介绍</h1>
        <p class="subtitle">专为中小企业打造的多租户AI客服解决方案</p>
      </section>

      <!-- 产品概述 -->
      <section class="section-overview">
        <div class="overview-text">
          <h2><span class="icon">🤖</span> 什么是小晖AI客服平台？</h2>
          <p>小晖AI客服平台是一个基于云服务的多租户智能客户服务系统。我们提供统一的平台，让不同规模的企业都能快速创建、管理和部署属于自己的独立AI客服机器人。</p>
          <div class="key-points">
            <div class="point">
              <span class="point-icon">🏢</span>
              <span class="point-text"><strong>多租户架构</strong> - 多个企业共享同一套基础设施，但数据完全隔离</span>
            </div>
            <div class="point">
              <span class="point-icon">⚡</span>
              <span class="point-text"><strong>快速部署</strong> - 10分钟完成配置，无需技术背景</span>
            </div>
            <div class="point">
              <span class="point-icon">🛡️</span>
              <span class="point-text"><strong>数据安全</strong> - 严格的数据隔离机制，保障企业隐私</span>
            </div>
            <div class="point">
              <span class="point-icon">💰</span>
              <span class="point-text"><strong>超低成本</strong> - 每月少喝一杯咖啡的价格，即可享受专业AI客服服务</span>
            </div>
          </div>
        </div>
        
        <!-- 两张图片并列展示 -->
        <div class="images-row">
          <div class="image-item">
            <img src="https://images.unsplash.com/photo-1542744095-fcf48d80b0fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="AI客服对话界面演示" class="demo-image" />
            <div class="image-caption">AI客服对话界面演示</div>
          </div>
          <div class="image-item">
            <img src="https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="多租户AI客服平台架构示意图" class="demo-image" />
            <div class="image-caption">多租户AI客服平台架构示意图</div>
          </div>
        </div>
      </section>

      <!-- 核心功能 -->
      <section class="section-features">
        <h2><span class="icon">✨</span> 核心功能</h2>
        
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">📚</div>
            <h3>智能知识库管理</h3>
            <ul>
              <li>支持多种文档格式上传</li>
              <li>智能文档解析与索引</li>
              <li>多版本知识库管理</li>
              <li>图文内容一体化</li>
            </ul>
          </div>
          
          <div class="feature-card">
            <div class="feature-icon">🔧</div>
            <h3>快速配置部署</h3>
            <ul>
              <li>可视化配置界面</li>
              <li>一键发布AI客服中心</li>
              <li>简单代码嵌入网站</li>
              <li>多域名支持</li>
            </ul>
          </div>
          
          <div class="feature-card">
            <div class="feature-icon">📊</div>
            <h3>数据分析与优化</h3>
            <ul>
              <li>自动解决率统计</li>
              <li>用户热点问题分析</li>
              <li>未命中问题追踪</li>
              <li>客户满意度监测</li>
            </ul>
          </div>
          
          <div class="feature-card">
            <div class="feature-icon">👥</div>
            <h3>团队协作管理</h3>
            <ul>
              <li>多角色权限分配</li>
              <li>员工绩效统计</li>
              <li>知识库协同编辑</li>
              <li>对话记录共享</li>
            </ul>
          </div>
        </div>
      </section>

      <!-- 技术优势 -->
      <section class="section-tech">
        <h2><span class="icon">🚀</span> 技术优势</h2>
        
        <div class="tech-grid">
          <div class="tech-item">
            <div class="tech-icon">🤖</div>
            <h4>先进的AI模型</h4>
            <p>集成多个主流AI模型，确保回答准确性和自然度</p>
          </div>
          
          <div class="tech-item">
            <div class="tech-icon">🔍</div>
            <h4>智能检索技术</h4>
            <p>基于语义理解的智能检索，精准匹配用户问题与知识库内容</p>
          </div>
          
          <div class="tech-item">
            <div class="tech-icon">⚡</div>
            <h4>高性能架构</h4>
            <p>分布式系统设计，支持高并发访问，保障99.9%服务可用性</p>
          </div>
          
          <div class="tech-item">
            <div class="tech-icon">🛡️</div>
            <h4>数据安全保障</h4>
            <p>端到端加密传输，严格的数据隔离机制，符合行业安全标准</p>
          </div>
        </div>
      </section>

      <!-- 版本对比 -->
      <section class="section-versions">
        <h2><span class="icon">📦</span> 版本对比</h2>
        
        <div class="versions-comparison">
          <div class="version-card">
            <div class="version-header">
              <h3>试用版</h3>
              <div class="version-price">免费试用一年</div>
            </div>
            <div class="version-features">
              <div class="feature included">✓ 基础知识库功能</div>
              <div class="feature included">✓ 1个AI客服中心</div>
              <div class="feature included">✓ 每月1000次对话</div>
              <div class="feature excluded">✗ 图文并茂回复</div>
              <div class="feature excluded">✗ 深度数据分析</div>
            </div>
          </div>
          
          <div class="version-card featured">
            <div class="version-badge">最受欢迎</div>
            <div class="version-header">
              <h3>基础版</h3>
              <div class="version-price">¥88/月</div>
            </div>
            <div class="version-features">
              <div class="feature included">✓ 完整知识库功能</div>
              <div class="feature included">✓ 3个AI客服中心</div>
              <div class="feature included">✓ 每月5000次对话</div>
              <div class="feature included">✓ 图文并茂回复</div>
              <div class="feature included">✓ 基础数据分析</div>
            </div>
          </div>
          
          <div class="version-card">
            <div class="version-header">
              <h3>团队版</h3>
              <div class="version-price">¥188/月</div>
            </div>
            <div class="version-features">
              <div class="feature included">✓ 高级知识库功能</div>
              <div class="feature included">✓ 10个AI客服中心</div>
              <div class="feature included">✓ 每月20000次对话</div>
              <div class="feature included">✓ 完整图文功能</div>
              <div class="feature included">✓ 深度数据分析</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 典型应用场景 -->
      <section class="section-scenarios">
        <h2><span class="icon">🎯</span> 典型应用场景</h2>
        
        <div class="scenarios-list">
          <div class="scenario-item">
            <h4>官网智能问答</h4>
            <p>自动回答产品、服务、价格、联系方式等常见问题，捕捉潜在销售线索</p>
          </div>
          
          <div class="scenario-item">
            <h4>小程序内置助手</h4>
            <p>解答用户在使用小程序时的操作问题，提升用户体验，减少卸载率</p>
          </div>
          
          <div class="scenario-item">
            <h4>电商自动客服</h4>
            <p>回复商品规格、发货时间、退换货政策等高频问题，减轻店主客服压力</p>
          </div>
          
          <div class="scenario-item">
            <h4>知识库查询</h4>
            <p>充当智能"活文档"，用户通过自然语言提问即可获取课程资料、会员权益等信息</p>
          </div>
        </div>
      </section>

      <!-- CTA区域 -->
      <section class="cta-section">
        <div class="cta-content">
          <h3>准备好开始了吗？</h3>
          <p>选择适合您业务需求的方案，10分钟快速部署专属AI客服</p>
          <div class="cta-buttons">
            <a href="/register" class="primary-btn">免费试用一年</a>
            <a href="/solutions" class="secondary-btn">查看行业方案</a>
          </div>
        </div>
      </section>
    </main>

    <!-- 备案信息页脚 -->
    <footer class="site-footer">
      <div class="footer-content">
        <p>
          © 2026 北京启明晨晖信息技术有限公司 版权所有
          <br/>
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">
            京ICP备2026004802号-1
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ProductIntro',
  data() {
    return {}
  }
}
</script>

<style scoped>
/* CSS变量定义 */
.ai-service-home {
  --space-blue: #0A1A35;
  --tech-blue: #1A4B8C;
  --ai-purple:  #00B4FF;
  --electric-blue: #00B4FF;
  --light-bg: #F0F4F9;
  --pure-white: #FFFFFF;
}
/* ========== 基础样式 ========== */
.industry-solutions {
  font-family: 'Alibaba PuHuiTi', 'Microsoft YaHei', sans-serif;
  min-height: 100vh;
  background: #ffffff;
}

/* ========== 导航栏样式 ========== */
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(10, 26, 53, 0.95);
  backdrop-filter: blur(8px);
  z-index: 1000;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 80px;
   padding: 15px max(20px, env(safe-area-inset-right)) 15px max(20px, env(safe-area-inset-left));
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-text {
  color: white;
  font-weight: bold;
  font-size: 1.3rem;
  white-space: nowrap;
}

.nav-links a {
  margin: 0 15px;
  text-decoration: none;
  color: white;
  position: relative;
  font-weight: 500;
  transition: all 0.3s;
}
/* 导航链接容器优化 */
.nav-links {
  display: flex;
  align-items: center;
  gap: 15px; /* 替代margin-right */
  padding-right: 20px; /* 替代margin-right */
  flex-wrap: nowrap; /* 防止换行 */
}
.nav-links a:hover {
  color: #00B4FF;
}

.nav-links a:hover::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--ai-purple);
  animation: underline 0.3s forwards;
}

@keyframes underline {
  from { width: 0; }
  to { width: 100%; }
}


.nav-links a.active::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #057FDB;
}

.nav-links .secondary-btn {
  background: transparent;
  color: white;
  border: 2px solid #057FDB;
  padding: 8px 20px;
  border-radius: 10px;
  font-weight: bold;
  transition: all 0.3s;
  margin-left: 10px;
  text-decoration: none;
}

.nav-links .secondary-btn:hover {
  background: rgba(5, 127, 219, 0.1);
  transform: translateY(-2px);
}

/* ========== 网站建设条 ========== */
.construction-banner {
  position: fixed;
  top: 80px;
  left: 0;
  width: 100%;
  background: #f0f7ff;
  color: #4a6fa5;
  text-align: center;
  padding: 6px 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.2;
  border-bottom: 2px solid #d1e3ff;
  box-sizing: border-box;
  z-index: 999;
  box-shadow: 0 3px 3px rgba(207, 189, 184, 0.3);
}

.construction-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* ========== 主要内容区域 ========== */
.main-content {
  max-width: 1200px;
  margin: 140px auto 0; /* 顶部留出导航栏和建设条空间 */
  padding: 0 20px;
}

/* 页面标题 */
.page-header {
  text-align: center;
  margin-bottom: 10px; /* 减小边距 */
  padding: 20px 0; /* 减小padding */
  border-bottom: 1px solid #eaeaea;
}

.page-header h1 {
  font-size: 2.2rem; /* 稍小一点 */
  color: #0A1A35;
  margin-bottom: 10px;
}

.page-header .subtitle {
  font-size: 1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* 新增：图片行样式 */
.images-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-top: 40px;
  margin-bottom: 40px;
}

.image-item {
  text-align: center;
}

.demo-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.demo-image:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.image-caption {
  text-align: center;
  color: #666;
  font-size: 0.9rem;
  margin-top: 12px;
  font-style: italic;
}

/* 产品概述文字部分 */
.overview-text {
  margin-bottom: 30px;
}

.overview-text h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.overview-text p {
  color: #444;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 25px;
}

.key-points {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

.point {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: #F0F8FF;
  border-radius: 8px;
  border-left: 4px solid #057FDB;
}

.point-icon {
  font-size: 1.2rem;
  flex-shrink: 0;
}

.point-text {
  color: #555;
  line-height: 1.5;
  font-size: 0.95rem;
}

/* 技术优势网格布局 */
.tech-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.tech-item {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s;
  border: 1px solid #e8f0fe;
}

.tech-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(5, 127, 219, 0.1);
  border-color: #057FDB;
}

.tech-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.tech-item h4 {
  color: #0A1A35;
  margin-bottom: 12px;
  font-size: 1.2rem;
}

.tech-item p {
  color: #666;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* 核心功能网格 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-top: 20px;
}

.feature-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 25px;
  transition: all 0.3s;
  border: 1px solid #e8f0fe;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(5, 127, 219, 0.1);
  border-color: #057FDB;
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.feature-card h3 {
  color: #057FDB;
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.feature-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-card li {
  padding: 6px 0;
  padding-left: 20px;
  position: relative;
  color: #555;
}

.feature-card li::before {
  content: "•";
  color: #057FDB;
  position: absolute;
  left: 0;
}

/* 版本对比 */
.versions-comparison {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-top: 20px;
}

.version-card {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 25px;
  position: relative;
  transition: all 0.3s;
}

.version-card:hover {
  border-color: #057FDB;
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.version-card.featured {
  border-color: #057FDB;
  border-width: 3px;
  box-shadow: 0 10px 30px rgba(5, 127, 219, 0.15);
}

.version-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #057FDB;
  color: white;
  padding: 4px 15px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
}

.version-header {
  text-align: center;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.version-header h3 {
  color: #0A1A35;
  margin-bottom: 10px;
  font-size: 1.5rem;
}

.version-price {
  color: #057FDB;
  font-size: 1.8rem;
  font-weight: bold;
}

.version-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature {
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}

.feature.included {
  color: #2E7D32;
}

.feature.excluded {
  color: #757575;
  text-decoration: line-through;
}

/* 应用场景 */
.scenarios-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.scenario-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #00B4FF;
  transition: transform 0.3s;
}

.scenario-item:hover {
  transform: translateY(-3px);
}

.scenario-item h4 {
  color: #0A1A35;
  margin-bottom: 10px;
}

.scenario-item p {
  color: #666;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* CTA区域 */
.cta-section {
  background: linear-gradient(135deg, #0A1A35, #162B50);
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  color: white;
  margin-top: 40px;
  margin-bottom: 60px;
}

.cta-content h3 {
  font-size: 1.8rem;
  margin-bottom: 15px;
  color: white;
}

.cta-content p {
  opacity: 0.9;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.primary-btn {
  background: #057FDB;
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.primary-btn:hover {
  background: #0468b7;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(5, 127, 219, 0.3);
}

.secondary-btn {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 10px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  font-size: 1rem;
}

.secondary-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .images-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .key-points {
    grid-template-columns: 1fr;
  }
  
  .features-grid,
  .tech-grid,
  .versions-comparison,
  .scenarios-list {
    grid-template-columns: 1fr;
  }
  
  .demo-image {
    max-height: 250px;
    object-fit: cover;
  }
}

.overview-text h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.overview-text p {
  color: #444;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 25px;
}

.key-points {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.point {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.point-icon {
  font-size: 1.2rem;
  flex-shrink: 0;
}

.point-text {
  color: #555;
  line-height: 1.5;
}

.demo-image {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.image-caption {
  text-align: center;
  color: #666;
  font-size: 0.9rem;
  margin-top: 10px;
  font-style: italic;
}

/* 核心功能区域 */
.section-features {
  margin-bottom: 60px;
}

.section-features h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
}

.feature-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 25px;
  transition: all 0.3s;
  border: 1px solid #e8f0fe;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(5, 127, 219, 0.1);
  border-color: #057FDB;
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.feature-card h3 {
  color: #057FDB;
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.feature-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-card li {
  padding: 6px 0;
  padding-left: 20px;
  position: relative;
  color: #555;
}

.feature-card li::before {
  content: "•";
  color: #057FDB;
  position: absolute;
  left: 0;
}

/* 技术优势区域 */
.section-tech {
  margin-bottom: 60px;
}

.section-tech h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.tech-stack {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.tech-item {
  background: #F0F8FF;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #057FDB;
}

.tech-item h4 {
  color: #0A1A35;
  margin-bottom: 10px;
}

.tech-item p {
  color: #666;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

.architecture-demo {
  margin-top: 30px;
}

.architecture-image {
  width: 100%;
  max-width: 800px;
  display: block;
  margin: 0 auto;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* 版本对比区域 */
.section-versions {
  margin-bottom: 60px;
}

.section-versions h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.versions-comparison {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
}

.version-card {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 25px;
  position: relative;
  transition: all 0.3s;
}

.version-card:hover {
  border-color: #057FDB;
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.version-card.featured {
  border-color: #057FDB;
  border-width: 3px;
  box-shadow: 0 10px 30px rgba(5, 127, 219, 0.15);
}

.version-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #057FDB;
  color: white;
  padding: 4px 15px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
}

.version-header {
  text-align: center;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.version-header h3 {
  color: #0A1A35;
  margin-bottom: 10px;
  font-size: 1.5rem;
}

.version-price {
  color: #057FDB;
  font-size: 1.8rem;
  font-weight: bold;
}

.version-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature {
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}

.feature.included {
  color: #2E7D32;
}

.feature.excluded {
  color: #757575;
  text-decoration: line-through;
}

/* 应用场景区域 */
.section-scenarios {
  margin-bottom: 60px;
}

.section-scenarios h2 {
  font-size: 1.8rem;
  color: #0A1A35;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.scenarios-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.scenario-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #00B4FF;
}

.scenario-item h4 {
  color: #0A1A35;
  margin-bottom: 10px;
}

.scenario-item p {
  color: #666;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* CTA区域 */
.cta-section {
  background: linear-gradient(135deg, #0A1A35, #162B50);
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  color: white;
  margin-top: 40px;
  margin-bottom: 60px;
}

.cta-content h3 {
  font-size: 1.8rem;
  margin-bottom: 15px;
  color: white;
}

.cta-content p {
  opacity: 0.9;
  margin-bottom: 30px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.primary-btn {
  background: #057FDB;
  color: white;
  padding: 12px 30px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.primary-btn:hover {
  background: #0468b7;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(5, 127, 219, 0.3);
}

.secondary-btn {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 10px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  font-size: 1rem;
}

.secondary-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* 页脚 */
.site-footer {
  background: #f5f5f5;
  border-top: 1px solid #eee;
  padding: 30px 5%;
  text-align: center;
  font-size: 0.85rem;
  color: #666;
}

.footer-content p {
  margin: 0;
  line-height: 1.6;
}

.site-footer a {
  color: #666;
  text-decoration: none;
  font-family: 'Courier New', Courier, monospace;
}

.site-footer a:hover {
  color: #1296db;
  text-decoration: underline;
}

/* 动画效果 */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-content {
    margin-top: 130px;
    padding: 0 15px;
  }
  
  .page-header {
    padding: 20px 0;
    margin-bottom: 30px;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .features-grid,
  .tech-stack,
  .versions-comparison,
  .scenarios-list {
    grid-template-columns: 1fr;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .nav-links {
    gap: 10px;
    padding-right: 10px;
  }
  
  .nav-links a {
    font-size: 0.9rem;
  }
}
.tech-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: start;
}
.tech-architecture {
  position: sticky;
  top: 160px; /* 固定在适当位置 */
}

.tech-features {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

@media (max-width: 992px) {
  .tech-content {
    grid-template-columns: 1fr;
  }
  
  .tech-architecture {
    position: static;
  }
}
@media (max-width: 480px) {
  .nav-bar {
    height: auto;
    padding: 10px;
    flex-wrap: wrap;
  }
  
  .nav-links {
    width: 100%;
    justify-content: center;
    margin-top: 10px;
    padding-right: 0;
  }
  
  .construction-banner {
    top: 120px; /* 导航栏变高后调整 */
  }
  
  .main-content {
    margin-top: 160px;
  }
}


</style>